var ESustainabilityType;
(function (ESustainabilityType) {
  ESustainabilityType["GREEN_PREMIUM"] = "GREEN_PREMIUM";
  ESustainabilityType["DEFAULT"] = "DEFAULT";
})(ESustainabilityType || (ESustainabilityType = {}));
var ESustainabilityGroupType;
(function (ESustainabilityGroupType) {
  ESustainabilityGroupType["DEFAULT"] = "DEFAULT";
  ESustainabilityGroupType["PRIMARY"] = "PRIMARY";
})(ESustainabilityGroupType || (ESustainabilityGroupType = {}));

export { ESustainabilityGroupType as E, ESustainabilityType as a };
